/* Load before native-case-cart.js. Only canonical paid history retires cart lines. */
(() => {
  let purchases = [];
  const acknowledged = new Set();
  window.apClearPurchaseHistory = () => {
    purchases = [];
    acknowledged.clear();
  };
  window.apNativeCartHistory = async (
    profile,
    reference,
    send,
    isCurrent = () => true,
  ) => {
    if (
      !Array.isArray(profile.completedReferences) ||
      !Array.isArray(profile.purchasedItems)
    )
      throw new Error("Purchase history unavailable.");
    const finished = new Set(profile.completedReferences);
    if (finished.size) {
      const response = await send("/cart.js", { cache: "no-store" });
      if (!response.ok) throw new Error("Cart unavailable.");
      const cart = await response.json();
      if (!Array.isArray(cart.items)) throw new Error("Cart unavailable.");
      const retired = cart.items.filter((line) =>
        finished.has(line.properties?._ap_shopping),
      );
      // Shopify line keys include properties: another pet or fresh shopping session is preserved.
      if (retired.some((line) => typeof line.key !== "string" || !line.key))
        throw new Error("Cart line cannot be identified.");
      for (const line of retired) {
        if (!isCurrent()) throw new Error("Shopping session changed.");
        const removed = await send("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: line.key, quantity: 0 }),
        });
        if (!removed.ok)
          throw new Error("Previous purchase cart cleanup failed.");
      }
    }
    if (finished.has(reference))
      throw new Error("Reopen your Care Page to place another order.");
    if (!isCurrent()) throw new Error("Shopping session changed.");
    purchases = profile.purchasedItems;
  };
  window.apConfirmRepeat = (items) => {
    const repeated = purchases.filter(
      (prior) =>
        items.some((item) => String(item.id) === prior.variantId) &&
        !acknowledged.has(prior.variantId),
    );
    if (!repeated.length) return true;
    const summary = [...new Set(repeated.map((p) => p.title))].join(", ");
    const confirmed = window.confirm(
      "You already ordered " + summary + ". Would you like to order another?",
    );
    if (confirmed) repeated.forEach((p) => acknowledged.add(p.variantId));
    return confirmed;
  };
})();
